import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function localeReducer(state = initialState.locale, action: any) {
  switch (action.type) {
    case types.SAVE_LOCALE_SUCCESS:
      return action.locale;
    default:
      return state;
  }
}
